<template>
  <b-table
    striped
    hover
    :items="items"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :busy.sync="loadingImages"
    show-empty
  >
    <template #cell(imagem)="{ item }">
      <span class="d-block" v-if="listThumbs[item.id]">
        <font-awesome-icon
          class="file-icon"
          :icon="listThumbs[item.id].source"
          v-if="listThumbs[item.id].icon"
        />
        <img :src="listThumbs[item.id].source" class="file-img" v-else />
      </span>
    </template>
    <template #cell(select)="{ item }">
      <b-form-checkbox v-model="selected" :value="item" name="file-select" />
    </template>
    <template #cell(legenda)="{ item }">
      <div class="d-inline-block text-truncate text-muted legenda-truncate">
      {{ item.legenda }}
      </div>
      <small class="d-block">
        {{
          item.extra_data && item.extra_data.extension
            ? item.extra_data.extension.toString().toUpperCase()
            : ""
        }}
        {{ item.storage_data?.size | prettyBytes }} - atualizado em
        {{ item.updated_at | format_date("DD [de] MMMM [de] YYYY") }}
      </small>
    </template>
    <template #cell(path)="{ item }">
      <font-awesome-icon icon="folder-open" />
      {{ item.path }}
    </template>

    <template #cell(oportunidades)="{ item }">
      {{ item.in.oportunidades }}
      <small class="d-block"> conselhos </small>
    </template>

    <template #cell(outros)="{ item }">
      {{ item.in.outros }} <small class="d-block"> usos </small>
    </template>

    <template #cell(actions)="{ item }">
      <Actions
        :item="item"
        :view_show="false"
        :view_edit="view_edit"
        :view_delete="view_delete"
        edit_to="files_edit"
        @delete="delete_file"
      >
        <b-button
          v-if="view_link"
          @click="visualizar(item)"
          target="_blank"
          variant="outline-info"
        >
          <font-awesome-icon icon="download" />
        </b-button>
      </Actions>
    </template>

    <template #table-busy>
      <div class="text-center text-exitos my-2">
        <b-spinner class="align-middle"></b-spinner>
      </div>
    </template>
    <template #empty="{}">
      <h5 class="text-center">Nenhum item encontado</h5>
    </template>
  </b-table>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapActions } from "vuex";

export default {
  components: { Actions },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    view_link: {
      type: Boolean,
      default: true,
    },
    view_edit: {
      type: Boolean,
      default: true,
    },
    view_delete: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      default: null,
    },
    perPage: {
      default: null,
    },
    max_select: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    selected: [],
    images: {},
    loadingImages: false,
  }),
  computed: {
    listThumbs() {
      const list = {};
      const items = this.items;
      for (let index = 0; index < items.length; index += 1) {
        const file = items[index];
        const isImage = file.mime_type.indexOf("image") !== -1;
        if (isImage) {
          list[file.id] = { source: file.url, icon: false };
        } else {
          const source = this.getIcon(file.extra_data.extension);
          list[file.id] = { source, icon: true };
        }
      }
      return list;
    },
  },
  methods: {
    ...mapActions("files", ["ActionsDownload", "ActionGetImage"]),
    delete_file(data) {
      this.$emit("delete", data);
    },
    getSelected() {
      return this.selected;
    },
    visualizar(item) {
      this.ActionsDownload(item);
    },
    getIcon(format) {
      const icons = {
        pdf: "file-pdf",
        xlsx: "file-excel",
        xls: "file-excel",
        pptx: "file-powerpoint",
        ppt: "file-powerpoint",
        pot: "file-powerpoint",
        pptm: "file-powerpoint",
        docx: "file-word",
        doc: "file-word",
      };
      return icons[String(format).replace(".", "")] || "file";
    },
  },
  watch: {
    async items() {
      this.loadingImages = true;
      await this.$nextTick();

      let idTimer;
      const delay = (time) =>
        new Promise((res) => (idTimer = setTimeout(res, time)));
      await delay(100);
      clearTimeout(idTimer);

      this.loadingImages = false;
    },
    selected() {
      if (this.max_select > 0) {
        while (this.selected.length > this.max_select) {
          this.selected.shift();
        }
      }
    },
  },
};
</script>

<style>
.file-img {
  width: 35px;
  object-fit: cover;
}
.file-icon {
  text-align: center;
  font-size: 1.75em;
}
.legenda-truncate {
  max-width: 40vw;
  min-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
